var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content shared-charge" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "is-append-query": false,
                  "show-more-scheme": true,
                  "show-simple": true,
                  "expand-adv": true,
                  "search-item-code": _vm.$t(
                    "CargoMsg.Cargo_SharedChargeRecord"
                  ),
                  "config-module": "513",
                  "auto-init": true,
                  "custom-search-items": _vm.customSearchItems,
                  "custom-sim-query-placeholder": _vm.$t(
                    "SystemMonitor.QuickSearchBusinessCode"
                  )
                },
                on: {
                  advSearchItemCallBack: _vm.fetchData,
                  simSearchItemCallBack: _vm.fetchDataBykeyWord
                }
              },
              [
                _c(
                  "template",
                  { slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.expandBtnClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.expandAllBtnLabel))]
                    )
                  ],
                  1
                ),
                _c("template", { slot: "searchAreaHeader" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "app-main-inner-row extension-conditions-form"
                    },
                    [
                      _c(
                        "el-form",
                        { attrs: { inline: true, "label-position": "left" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-search",
                              attrs: {
                                label: _vm.$t(
                                  "WriteOff.revenueAndExpenditureMethod"
                                )
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.searchConditions.isAr,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchConditions,
                                        "isAr",
                                        $$v
                                      )
                                    },
                                    expression: "searchConditions.isAr"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: -1 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.all")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("WriteOff.receivables"))
                                    )
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.payables")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-search",
                              attrs: { label: _vm.$t("WriteOff.feeType") }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.searchConditions.isOversea,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.searchConditions,
                                        "isOversea",
                                        $$v
                                      )
                                    },
                                    expression: "searchConditions.isOversea"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: -1 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.all")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v(_vm._s(_vm.$t("WriteOff.domestic")))
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("WriteOff.international"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-search",
                              attrs: {
                                label: _vm.$t("Invoice.invoice_businessDate")
                              }
                            },
                            [
                              _c(
                                "el-row",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "date",
                                              clearable: false,
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.pickerOptions,
                                              editable: false
                                            },
                                            model: {
                                              value:
                                                _vm.searchConditions
                                                  .inputDateStart,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.searchConditions,
                                                  "inputDateStart",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searchConditions.inputDateStart"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("Invoice.invoice_dateTo"))
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c("el-date-picker", {
                                            attrs: {
                                              type: "date",
                                              clearable: "",
                                              "value-format": "yyyy-MM-dd",
                                              "picker-options":
                                                _vm.pickerOptions
                                            },
                                            model: {
                                              value:
                                                _vm.searchConditions
                                                  .inputDateEnd,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.searchConditions,
                                                  "inputDateEnd",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searchConditions.inputDateEnd"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { "label-width": "0" } },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: _vm.allowTwoYearOutside,
                                                callback: function($$v) {
                                                  _vm.allowTwoYearOutside = $$v
                                                },
                                                expression:
                                                  "allowTwoYearOutside"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "Invoice.invoice_queryLotsOfData"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "min-height": "350px" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    "config-module": "191201",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "check-main-record": false,
                    "deselect-main-record": false,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-selected-color": false
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }